import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Staffs from './Admin';
import Physician from './Physician';
import Nurse from './Nurse';
import $ from 'jquery';
import ErrorBoundary from '../../ErrorBoundary';

class UsersTabSettings extends Component {
    constructor() {
        super();
        this.state = {
            physicianRole: false,
            procedureAdminRole: false
        }
    }
    componentDidMount() {
        console.log("UsersTabSettings Mounted!");
        var thisController = this;
        var userRoleData = JSON.parse(localStorage.getItem("user_details"));

        if (userRoleData != null) {
            var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];

            if (userRole == 'PROCEDURE_ADMIN') {
                thisController.state.procedureAdminRole = true;
                thisController.setState(thisController.state);
            } else if (userRole == 'PHYSICIAN') {
                thisController.state.physicianRole = true;

            }
        } else {
            window.location.href = "/my-jeeva/login";
        }



        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/my-jeeva/projectmgmt";
            var path1 = window.origin + "/my-jeeva/projectmgmt/";
            var rolePath = window.origin + "/my-jeeva/projectmgmt";
            if (currentPath == path || currentPath == path1) {
                $("#physician").addClass('active');
            } else {
                $("#" + localStorage.getItem("last-project-user-tab")).addClass('active')
            }
            $("#physician")
                .on("click", function () {
                    $("#physician")
                        .removeClass('active');
                    localStorage.setItem("last-project-user-tab", $(this)[0].id);

                    $(this).addClass('active')

                })



        })();
    }

    render() {
        return (
            <ErrorBoundary>
            <div id="tabPage">
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />


                    <div className="container-fluid" >
                        {/* Nav tabs */}
                        <div className="tab-class" style={{ marginLeft: '1vw' }}>

                            <ul >
                                <Link className="nav-item" data-toggle="tab"
                                    to={"/projectmgmt"}
                                    style={{
                                        display: (window.SCOPE_VALUE.CURRENT > window.SCOPE_VALUE.PHYSICIAN) ? 'none' : 'block',
                                        textDecoration: 'none',
                                        //  display: this.state.showPhysician ? 'block' : 'none'
                                    }}>
                                    <li className="nav-link" id="physician" style={{ marginRight: '15px', display: this.state.physicianRole ? 'none' : 'block' }}>
                                        Physician
                                    </li></Link>

                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route exact path="/projectmgmt"
                        component={Physician}></Route>
                </Switch>
            </div>
            </ErrorBoundary>
        );
    }
}
export default UsersTabSettings;




// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/UsersTabSettings.js